import Vue, { onUnmounted } from 'vue';
import CRender from '@/components/shared/CRender.vue';
import { TYPE } from 'vue-toastification';
import type { ToastOptions } from 'vue-toastification/dist/types/src/types';

export const useToaster = () => {
    const toast = Vue.$toast;

    const show = (template: string, options?: ToastOptions) => {
        toast(
            {
                component: CRender,
                props: { content: template }
            },
            options
        );
    };

    const error = (template: string) => {
        show(template, {
            type: TYPE.ERROR
        });
    };

    onUnmounted(() => {
        toast.clear();
    });

    return { toast: toast, show, error };
};
